import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// istanbul ignore next
class ShowHide extends React.Component {
  constructor(props) {
    super(props);
    this.wasOpen = false;
  }

  componentDidMount() {
    this.rendered = true;
  }

  onTransitionEnd = (e) => {
    const {
      isOpen,
      scrollTo,
      onToggle = () => {},
    } = this.props;

    if (e.propertyName !== 'height') {
      return;
    }

    if (isOpen && scrollTo) {
      this.el.style.height = 'auto';
      this.el.scrollIntoView({
        behavior: 'smooth',
      });
      onToggle(true);
    } else if (isOpen) {
      this.el.style.height = 'auto';
      onToggle(true);
    } else {
      this.el.style.height = 0;
      this.el.style.display = 'none';
      onToggle(false);
    }
  }

  getHeight() {
    const { isOpen } = this.props;

    let height = 0;

    if (!this.el) {
      return height;
    }

    this.toggleTransition(true);

    if (isOpen) {
      this.el.style.display = 'block';
      this.el.style.height = 'auto';
      height = this.el.offsetHeight;
    }

    this.el.style.height = isOpen ? 0 : `${this.el.offsetHeight}px`;

    this.toggleTransition(false);

    return height;
  }

  toggleTransition(add) {
    const { noTransitionClass } = this.props;

    const methodName = add ? 'add' : 'remove';

    this.el.classList[methodName](noTransitionClass);

    // trigger reflow
    // eslint-disable-next-line no-unused-expressions
    this.el.offsetHeight;
  }

  render() {
    const {
      children,
      isOpen,
      extraProps,
      extraClass,
    } = this.props;

    const showHideCssClass = classNames('u-show-hide', {
      [`${extraClass}`]: extraClass,
      'u-show-hide--is-shown': isOpen,
    });

    const style = {};

    // Only calculate the height after the component
    // has been added to the DOM and isOpen has been toggled
    if (this.wasOpen !== isOpen && this.rendered) {
      style.height = `${this.getHeight()}px`;
    } else if (isOpen) {
      style.height = 'auto';
    }

    this.wasOpen = isOpen;

    return (
      <div
        data-test="show-hide-element"
        ref={(el) => { this.el = el; }}
        className={showHideCssClass}
        style={style}
        onTransitionEnd={this.onTransitionEnd}
        aria-hidden={!isOpen}
        {...extraProps}
      >
        { children }
      </div>
    );
  }
}

ShowHide.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  noTransitionClass: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  extraProps: PropTypes.objectOf(PropTypes.string),
  extraClass: PropTypes.string,
  scrollTo: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default ShowHide;
